import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import classes from './MonthFilter.module.scss';
import BasicFilterDropdown from '../BasicFilterDropdown/BasicFilterDropdown';
import { useWindowSize } from '../../../../../../utils/hooks';
import { months, responsiveSizeTimesheet } from '../../../../../../utils/constants';
import CustomMonthPicker from '../../../../CustomMonthPicker/CustomMonthPicker';
import MainButton from '../../../../buttons/MainButton';
import colors from '../../../../../../scss/colors';
import { generalEnums } from '../../../../../../utils/enums';

export default function MonthFilter({
  filterMonths = [],
  years = [],
  selectedMonth,
  selectedYear,
  changeMonth,
  changeYear,
  dateBackAction,
  dateForwardAction
}) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const size = useWindowSize();
  const filteredMonths = months(t).filter((mth) => filterMonths.includes(mth));

  const handleFilterToggle = () => {
    setOpen(!open);
    dateBackAction(
      selectedYear || selectedMonth
        ? `${selectedYear}-${selectedMonth || '01'}-01`
        : dayjs().format(generalEnums.DATEFORMAT)
    );
  };

  return (
    <BasicFilterDropdown
      type={t('dashboard.timesheets.filters.month')}
      text={t('dashboard.timesheets.filters.month')}
      active={!!selectedMonth}
      open={open}
      setOpen={handleFilterToggle}
      sxBox={{
        padding: 0
      }}
      extraHeader={{
        enabled: !!selectedMonth,
        label: t('common.filters.reset'),
        action: () => {
          changeMonth('');
          changeYear('');
          setOpen(false);
        }
      }}
    >
      <div className={classes.container}>
        <CustomMonthPicker
          dateDisablingAbility
          daysAvailability={{ months: filteredMonths, years }}
          setMonth={(month) => {
            changeMonth(month);
            setOpen(false);
          }}
          setYear={(year, month) => changeYear(year, month)}
          month={selectedMonth}
          year={selectedYear || new Date().getFullYear()}
          dateBackAction={dateBackAction}
          dateForwardAction={dateForwardAction}
        />
      </div>
      <div className={classes.resetFilterContainer}>
        {!!selectedMonth && size.width > responsiveSizeTimesheet && (
          <MainButton
            outlined
            rounded
            size={size.width < responsiveSizeTimesheet ? 'small' : 'xsmall'}
            forceWidth={size.width < responsiveSizeTimesheet ? '100%' : '136px'}
            action={() => {
              changeMonth('');
              changeYear('');
              setOpen(false);
            }}
            sx={{
              color: colors.MEDIUM_GREY,
              borderColor: colors.MEDIUM_GREY
            }}
          >
            <p>{t('dashboard.timesheets.filters.reset')}</p>
          </MainButton>
        )}
      </div>
    </BasicFilterDropdown>
  );
}
